/*
 *  Author: DL
 *  Date: 2020-12-04 22:46:37
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-18 09:57:30
 *  LastEditors: DL
 *  Description: 历史记录
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React, { useCallback, useContext, useState, useEffect, useRef } from 'react';
import Context from '@/hook/useFmapContext';
import { getHistoricalData, updateHistoricalData, getItemByFID, clearHistoryData, isExist } from 'utils/history';
import styles from './index.less';

export default function (props) {
    const { fmap } = useContext(Context);
    const { keyword = '', onLiClick } = props;

    const [data, setData] = useState([]);
    const [historyData, setHistoryData] = useState(getHistoricalData());
    const globalRef = useRef({ intervalTimer: -1 });

    const updatePositionMarker = useCallback(
        fid => {
            const coordCenter = fmap.getMapCoordToCenter(fid);
            if (coordCenter) {
                fmap.updatePositionMarker(coordCenter);
                fmap.map.moveTo({ ...coordCenter });
                fmap.map.tiltAngle = 90;
            }
        },
        [fmap],
    );

    const handleClearHistoryData = useCallback(() => {
        clearHistoryData();
        setHistoryData([]);
    }, []);

    // 点击 搜索结果
    const handleLiClick = useCallback(
        event => {
            const fid = event.target.dataset.fid;
            const item = data.filter(({ FID }) => fid === FID)[0];

            if (item && !isExist(item.FID)) {
                const data = updateHistoricalData(item);
                setHistoryData(data);
            }

            updatePositionMarker(fid);
            onLiClick(item);
        },
        [data, onLiClick, updatePositionMarker],
    );

    // 点击 历史记录
    const handleLiHistoryClick = useCallback(
        event => {
            const fid = event.target.dataset.fid;
            const item = getItemByFID(fid);
            if (item) {
                updatePositionMarker(fid);
                onLiClick(item);
            }
        },
        [onLiClick, updatePositionMarker],
    );

    useEffect(() => {
        let res = [];

        if (keyword.trim()) {
            if (fmap && fmap.loadCompleteStatus) {
                res = fmap.mapSearchByParams([
                    { key: 'keyword', value: keyword },
                    { key: 'nodeType', value: 12 },
                ]);
            } else {
                globalRef.current.intervalTimer = setInterval(() => {
                    if (fmap && fmap.loadCompleteStatus) {
                        clearInterval(globalRef.current.intervalTimer);
                        res = fmap.mapSearchByParams([
                            { key: 'keyword', value: keyword },
                            { key: 'nodeType', value: 12 },
                        ]);

                        res.filter(item => item.name !== '');

                        setData(res);
                    }
                }, 500);
            }
        }

        res.filter(item => item.name !== '');

        setData(res);
    }, [keyword, fmap]);

    return (
        <div className={styles.wrapper}>
            {data.length === 0 ? <h1>历史记录</h1> : null}
            <ul className={styles.list}>
                {data.length === 0
                    ? historyData.map(({ FID, name, floor }) => (
                        <li key={FID} data-fid={FID} onClick={handleLiHistoryClick}>
                            {name}
                            <span className={styles.floor} data-fid={FID}>
                                {floor}
                            </span>
                        </li>
                    ))
                    : data.map(({ FID, name, floor }) => (
                        <li key={FID} data-fid={FID} onClick={handleLiClick}>
                            {name}
                            <span className={styles.floor} data-fid={FID}>
                                {floor}
                            </span>
                        </li>
                    ))}
            </ul>
            {data.length > 0 ? null : <p onClick={handleClearHistoryData}>清空历史记录</p>}

        </div>
    );
}
